import React from "react";
import { useSelector } from "react-redux";
import ImageCarousel from "../../secondary/ImageCarousel/ImageCarousel";

export function CharacteristicReferenceImages({ setReferenceImage, styles }) {
  const images = useSelector((state) => state.patient.touchViewImages);
  return (
    <div>
      {/* Back button */}
      <button className={styles.reference_images} onClick={() => setReferenceImage(false)}>
        Back
      </button>

      <br />

      {/* Carousel block */}
      <div className={styles.carousel_block}>
        {images &&
          images.length > 0 &&
          images.map((data, index) => <ImageCarousel key={index} title={data?.title} images={data?.referencePictures} />)}
      </div>
    </div>
  );
}
